'use strict';

exports.__esModule = true;

var _ContextProps = require('../types/ContextProps');

var _get = require('../utils/get');

var _sanitizeUrl = require('../utils/sanitize-url');

var IDs = {
  PAGE_NAME: 'page.name',
  PAGE_URL: 'page.url',
  SITE_NAME: 'site.name',
  HOME_PAGE_TITLE: 'site.homePageTitle',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  IS_HOME_PAGE: 'page.isHomePage',
  TITLE: 'page.title',
  DESCRIPTION: 'page.description',
  IMAGE: 'page.image',
  IMAGE_WIDTH: 'page.imageWidth',
  IMAGE_HEIGHT: 'page.imageHeight',
  FB_ADMINS: 'site.facebookAdminId',
  NEXT: 'site.nextLink',
  PREV: 'site.prevLink'
};

exports.default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.PAGE_NAME] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.PAGE_NAME), _ref[IDs.PAGE_URL] = (0, _sanitizeUrl.sanitizeUrl)((0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.DEFAULT_URL)), _ref[IDs.SITE_NAME] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.HOME_PAGE_TITLE] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.HOME_PAGE_TITLE), _ref[IDs.INDEX_SITE] = (0, _get.getRawValue)(item, 'context.' + _ContextProps.CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = (0, _get.getRawValue)(item, 'context.' + _ContextProps.CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.IS_HOME_PAGE] = (0, _get.getRawValue)(item, 'context.' + _ContextProps.CONTEXT_PROPS.IS_HOME_PAGE), _ref[IDs.TITLE] = getTitle(item), _ref[IDs.DESCRIPTION] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.DESCRIPTION), _ref[IDs.IMAGE] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.OG_IMAGE) || (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_OG_IMAGE), _ref[IDs.IMAGE_WIDTH] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.OG_IMAGE_WIDTH), _ref[IDs.IMAGE_HEIGHT] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.OG_IMAGE_HEIGHT), _ref[IDs.FB_ADMINS] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.FB_ADMINS), _ref[IDs.NEXT] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.NEXT), _ref[IDs.PREV] = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.PREV), _ref;
  },
  getBiData: function getLegacySeoBlob() {
    return { id: null, name: null };
  },
  getLegacySeoBlob: function getLegacySeoBlob() {
    return { tags: [] };
  },
  getKeys: function getKeys() {
    return Object.keys(IDs).map(function (id) {
      return { id: id };
    });
  }
};


function getTitle(item) {
  var title = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.TITLE);
  if (title) {
    return title;
  }

  var isHomePage = (0, _get.getRawValue)(item, 'context.' + _ContextProps.CONTEXT_PROPS.IS_HOME_PAGE);
  if (isHomePage) {
    var _siteName = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_NAME);
    return _siteName || '';
  }

  var homePageTitle = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.HOME_PAGE_TITLE);
  var siteName = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.SITE_NAME);
  var pageName = (0, _get.get)(item, 'context.' + _ContextProps.CONTEXT_PROPS.PAGE_NAME);

  return [pageName, homePageTitle || siteName].filter(function (_) {
    return !!_;
  }).join(' | ');
}